import Axios from 'axios';
import { protectedResources } from '../authConfig';
import { shareInFlight } from '../helpers/shareInFlight';

const URL =
  protectedResources.apiHRMobile.baseApi +
  '/api/v1/AdvanceSalary/GetCutOffCalendar';
const URL_UPLOAD =
  protectedResources.apiHRMobile.baseApi +
  '/api/v1/BackOffice/UploadCutOffCalendar';
let tokenKey;

// Menubar and PayrollCutoffLastDowload both ask for the image on the home page; share one request.
const inFlight = new Map();

export async function getImgCalendarCutoff() {
  return shareInFlight(inFlight, 'calendar', loadImgCalendarCutoff);
}

async function loadImgCalendarCutoff() {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  try {
    // Use sessionStorage cache for fast load
    const cache = sessionStorage.getItem('payroll_cutoff_img');
    if (cache) {
      return JSON.parse(cache);
    }
    const response = await Axios.get(URL, config);
    const result = { cutOffCalendar: response.data };
    sessionStorage.setItem('payroll_cutoff_img', JSON.stringify(result));
    return result;
  } catch (error) {
    console.error(error);
  }
}

export async function UploadImgCalendarCutoff(fileInput) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }
  var formData = new FormData();
  var imagefile = document.querySelector('#file');
  formData.append('Image', fileInput);
  const config = {
    headers: {
      Authorization: `Bearer ${tokenKey}`,
      'Content-Type': 'multipart/form-data',
    },
  };
  try {
    const response = await Axios.post(URL_UPLOAD, formData, config);
    return await { cutOffCalendar: response.data };
  } catch (error) {
    console.error(error);
  }
}
